import { reportSpecialUnitsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SPECIAL_UNITS_FILTERS,
  RESTORE_INITIAL
} = reportSpecialUnitsTypes;

const initialState = {
  startDate: newDate(),
  station: null, // Solo se usa para la búsqueda de clientes en CustomerComponent, no se envía al reporte
  customer: null,
};

export const reportSpecialUnitsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SPECIAL_UNITS_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
